// src/data/geoPages.js
// Geo-specific landing pages — Option B SEO (standalone routes, not /category/)

export const GEO_PAGES = {
  "uk-cam-girls": {
    path: "/uk-cam-girls",
    metaTitle: "UK Cam Girls Live — British Models Streaming Now | InstaCamGirls",
    metaDesc: "Watch UK cam girls streaming live right now. Real British models — English, Scottish, Welsh — in free chat on InstaCamGirls. No signup needed.",
    keywords: "uk cam girls, british cam girls, english cam girls live, british webcam girls, uk live cams",
    canonical: "https://instacamgirls.com/uk-cam-girls",
    h1: "UK Cam Girls — British Models Live Now",
    intro: "There's something unmistakably appealing about British cam girls — the accent, the dry wit, the confidence. Whether you prefer a soft English lilt, a lilting Scottish brogue, or the sharp warmth of a Welsh model, UK cam girls bring a distinctly different energy to the live cam world. Browse free, no signup required.",
    wlUrl: "https://instacamgirlslive.com/live/uk",
    ctaText: "Watch UK Cam Girls Live Now →",
    whyTitle: "Why UK Cam Girls Stand Out",
    whyPoints: [
      "Real British accents — English, Scottish, Welsh, Northern Irish models streaming 24/7",
      "High fluency in English makes chat feel natural and genuinely personal",
      "Peak hours: 5–11 PM GMT (12–6 PM EST) — hundreds online every evening",
      "Known for wit and personality in free chat — conversation, not just performance",
    ],
    faq: [
      { q: "Are these real UK-based cam girls?", a: "Yes — these are verified British models streaming live. You'll hear real UK accents in chat." },
      { q: "When are UK cam girls most active?", a: "Peak hours are 5–11 PM GMT (12–6 PM EST), though many stream around the clock." },
      { q: "Is it free to watch?", a: "Free chat is always open. Private shows require credits." },
    ],
    categoryLink: "/category/uk-cam-girls",
    categoryLinkText: "Browse all UK cam girls on InstaCamGirls",
    sitemapPriority: "0.8",
  },

  "french-cam-girls": {
    path: "/french-cam-girls",
    metaTitle: "French Cam Girls Live — Francophone Models Streaming Now | InstaCamGirls",
    metaDesc: "French cam girls live right now. Francophone models from France, Quebec, Belgium streaming free. Chat en français or English — go private anytime.",
    keywords: "french cam girls, cam filles françaises, french live cams, francophone cam girls, french webcam models",
    canonical: "https://instacamgirls.com/french-cam-girls",
    h1: "French Cam Girls — Francophone Models Live Now",
    intro: "French cam girls are in a class of their own. The language, the attitude, the effortless sensuality — francophone models from France, Quebec, Belgium, and Switzerland bring an unmistakable quality to live cam shows. Chat in French or English, watch free, and go private whenever you're ready.",
    wlUrl: "https://instacamgirlslive.com/live/french",
    ctaText: "Watch French Cam Girls Live Now →",
    whyTitle: "What Makes French Cam Girls Different",
    whyPoints: [
      "Francophone models from France, Quebec, Belgium, and Switzerland — real French speakers",
      "Bilingual performers — comfortable in both French and English",
      "Known for elegance, confidence, and genuine personality in chat",
      "Peak hours: 7–11 PM CET (1–5 PM EST) — strong French evening activity",
    ],
    faq: [
      { q: "Can I chat in French?", a: "Absolutely — type in French and French-speaking models respond in kind." },
      { q: "Are these models from France specifically?", a: "French-speaking models come from France, Quebec, Belgium, and Switzerland. Many are from France." },
      { q: "Is it free to watch?", a: "Yes — free chat is always open. Credits needed for private shows." },
    ],
    categoryLink: "/category/french-cam-girls",
    categoryLinkText: "Browse all French cam girls on InstaCamGirls",
    sitemapPriority: "0.8",
  },

  "colombian-cam-girls": {
    path: "/colombian-cam-girls",
    metaTitle: "Colombian Cam Girls Live — Colombia Models Streaming Now | InstaCamGirls",
    metaDesc: "Colombian cam girls live right now. Real models from Medellín, Bogotá, and Cali streaming free. Browse the #1 source for Colombian live cams.",
    keywords: "colombian cam girls, colombia cam models, medellin cam girls, colombian live cams, cam girls colombia",
    canonical: "https://instacamgirls.com/colombian-cam-girls",
    h1: "Colombian Cam Girls — Live Models from Colombia",
    intro: "Colombia produces some of the most stunning cam models in the world — and for good reason. Medellín, Bogotá, Cali, and Barranquilla are home to thousands of professional cam models known for their passion, warmth, and high-energy shows. Whether you're looking for a casual conversation or an intense private session, Colombian cam girls deliver.",
    wlUrl: "https://instacamgirls.com/category/colombian-cam-girls",
    ctaText: "Browse Colombian Cam Girls Live →",
    whyTitle: "Why Colombian Cam Girls Are So Popular",
    whyPoints: [
      "Colombia is the #1 country for live cam models globally — the talent pool is unmatched",
      "Most models from Medellín, Bogotá, and Cali — cities known for producing professional performers",
      "Bilingual — most Colombian cam girls speak both Spanish and English",
      "Known for high-energy free chat and exceptional private show value",
    ],
    faq: [
      { q: "Why are so many cam girls Colombian?", a: "Colombia has a thriving cam industry — it's a professional career path with strong community support, especially in Medellín." },
      { q: "Do Colombian cam girls speak English?", a: "Most do — especially models who have been performing for more than a year." },
      { q: "Is it free to watch?", a: "Yes — free chat is always open. Credits needed for private shows." },
    ],
    categoryLink: "/category/colombian-cam-girls",
    categoryLinkText: "Browse all Colombian cam girls on InstaCamGirls",
    sitemapPriority: "0.85",
  },

  "german-cam-girls": {
    path: "/german-cam-girls",
    metaTitle: "German Cam Girls Live — Deutsche Models Streaming Now | InstaCamGirls",
    metaDesc: "German cam girls live right now. Real Deutsche models from Berlin, Munich, Hamburg streaming free. Bilingual German and English performers 24/7.",
    keywords: "german cam girls, deutsche cam girls, german live cams, germany webcam girls, berlin cam girls",
    canonical: "https://instacamgirls.com/german-cam-girls",
    h1: "German Cam Girls — Deutsche Models Live Now",
    intro: "German cam girls are known for being direct, confident, and intensely interactive. Whether you prefer chatting auf Deutsch or in English, Deutsche cam models from Berlin, Munich, Hamburg, and Cologne deliver a distinctly European quality to their shows. No games, no pretense — just real performances from real German women.",
    wlUrl: "https://instacamgirlslive.com/live/german",
    ctaText: "Watch German Cam Girls Live Now →",
    whyTitle: "What to Expect from German Cam Girls",
    whyPoints: [
      "Models from Berlin, Munich, Hamburg, Cologne, and Frankfurt — verified German performers",
      "Bilingual streams — German and English, often switching naturally mid-show",
      "Known for directness and high interactive quality in private shows",
      "Peak hours: 6–11 PM CET (12–5 PM EST) — strong Central European evening activity",
    ],
    faq: [
      { q: "Do German cam girls speak English?", a: "Most are bilingual — German and English. Many stream in both languages." },
      { q: "Are these models actually based in Germany?", a: "Yes — verified German models. You'll often see German in the chat naturally." },
      { q: "When are German cam girls online?", a: "Peak hours are 6–11 PM CET (12–5 PM EST), though many stream around the clock." },
    ],
    categoryLink: "/category/german-cam-girls",
    categoryLinkText: "Browse all German cam girls on InstaCamGirls",
    sitemapPriority: "0.8",
  },

  "romanian-cam-girls": {
    path: "/romanian-cam-girls",
    metaTitle: "Romanian Cam Girls Live — Romania Models Streaming Now | InstaCamGirls",
    metaDesc: "Romanian cam girls live right now. Romania is the #1 cam model country in the world — watch the best live now. Free chat, no signup needed.",
    keywords: "romanian cam girls, romania cam models, romanian live cams, romanian webcam girls, eastern european cam girls",
    canonical: "https://instacamgirls.com/romanian-cam-girls",
    h1: "Romanian Cam Girls — The World's Top Cam Model Country",
    intro: "If you know live cams, you know Romania. More professional cam models come from Romania than any other country on earth — Bucharest, Cluj-Napoca, and Constanța are home to the largest concentrations of professional cam studios globally. Romanian cam girls are experienced, professional, fluent in English, and known for delivering some of the highest-quality shows in the industry.",
    wlUrl: "https://instacamgirls.com/category/romanian-cam-girls",
    ctaText: "Browse Romanian Cam Girls Live →",
    whyTitle: "Why Romanian Cam Girls Are the Industry Standard",
    whyPoints: [
      "Romania is the global #1 for professional cam models — more performers per capita than any country",
      "Bucharest and Cluj-Napoca host thousands of professional cam studios",
      "Romanian models are known for professionalism, reliability, and exceptional show quality",
      "Nearly all are fluent in English — many also speak French, Italian, or Spanish",
    ],
    faq: [
      { q: "Why are there so many Romanian cam girls?", a: "Romania developed a thriving cam industry starting in the early 2000s. It's now a mainstream profession with professional studios and high industry standards." },
      { q: "Do Romanian cam girls speak English?", a: "Yes — almost universally. Most also speak one or two additional European languages." },
      { q: "Is it free to watch?", a: "Yes — free chat is always open. Credits needed for private shows." },
    ],
    categoryLink: "/category/romanian-cam-girls",
    categoryLinkText: "Browse all Romanian cam girls on InstaCamGirls",
    sitemapPriority: "0.8",
  },

  "latina-cam-girls-live": {
    path: "/latina-cam-girls-live",
    metaTitle: "Latina Cam Girls Live Now — Colombian, Mexican & Brazilian Models | InstaCamGirls",
    metaDesc: "Latina cam girls streaming live right now. Colombian, Mexican, Brazilian, and Venezuelan models in free chat. The hottest Latin cam girls, 24/7.",
    keywords: "latina cam girls live, latina live cams now, colombian cam girls live, mexican cam girls live, latina webcam models",
    canonical: "https://instacamgirls.com/latina-cam-girls-live",
    h1: "Latina Cam Girls Live — Streaming Right Now",
    intro: "Hundreds of Latina cam girls are live right now — Colombian beauties from Medellín, fiery Mexican models, passionate Venezuelan performers, and stunning Brazilian girls. Latina cam shows are known for high energy, incredible dancing, and genuine enthusiasm. Browse free, no signup needed, and go private whenever you're ready.",
    wlUrl: "https://instacamgirlslive.com/live/latina",
    ctaText: "Watch Latina Cam Girls Live Now →",
    whyTitle: "Why Latina Cam Shows Are the Most Popular",
    whyPoints: [
      "Colombia, Mexico, Venezuela, Brazil, and Argentina — the full spectrum of Latin beauty live",
      "Known for high-energy shows, incredible dancing, and genuine passion",
      "Most Latina cam girls are live evenings EST — 7 PM–2 AM for peak activity",
      "Many are bilingual — Spanish and English — making chat feel personal and natural",
    ],
    faq: [
      { q: "What countries are Latina cam girls from?", a: "Primarily Colombia, Mexico, Venezuela, Brazil, and Argentina. Colombian models are the most numerous." },
      { q: "Do Latina cam girls speak English?", a: "Many do, especially models who've been performing for a year or more. Spanish is common in free chat." },
      { q: "When are Latina cam girls most active?", a: "7 PM–2 AM EST is peak time for Colombian/Venezuelan models. Brazilian models are slightly later." },
    ],
    categoryLink: "/category/latina-cam-girls",
    categoryLinkText: "Browse all Latina cam girls on InstaCamGirls",
    sitemapPriority: "0.85",
  },
};

export default GEO_PAGES;
